import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import i18n from "../../../translations/i18n";
import classNames from "classnames/bind";
import cl from "./LanguageSelect.module.scss";

// This component was used temporarily to allow QA to test switching
// languages before full feature implementation
const LanguageSelect = (): React.ReactElement => {
  const cx = classNames.bind(cl);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const resources = i18n.options.resources ?? ({} as Object);
  const [languages, setLanguages] = useState<string[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [filteredLanguage, setFilteredLanguage] = useState<string[]>([]);

  useEffect(() => {
    if (resources) {
      setLanguages(Object.keys(resources));
    }
  }, [resources]);

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const searchLanguage = (event: any) => {
    setTimeout(() => {
      let _filteredLanguage;
      if (!event.query.trim().length) {
        _filteredLanguage = [...languages];
      } else {
        _filteredLanguage = languages.filter((language) => {
          return language;
        });
      }

      setFilteredLanguage(_filteredLanguage);
    }, 250);
  };

  const itemTemplate = (item: any) => {
    return (
      <div className="language-item">
        <div>{item}</div>
      </div>
    );
  };

  return (
    <AutoComplete
      value={selectedLanguage}
      suggestions={filteredLanguage}
      completeMethod={searchLanguage}
      field="lang"
      dropdown
      itemTemplate={itemTemplate}
      onChange={(e) => setSelectedLanguage(e.value)}
      aria-label="Languages"
      className={cx(cl.languageSelect)}
    />
  );
};

export default LanguageSelect;
